<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo">
            <b-img
              height="24"
              width="36"
              :src="skin == 'light' ? appLogoImage : darkLogoImage"
              alt="logo"
            />
          </span>
          <h2 class="brand-text pl-0">
            {{ appName }}
          </h2>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { skin, appName, appLogoImage, darkLogoImage } = $themeConfig.app
    return {
      skin,
      appName,
      appLogoImage,
      darkLogoImage
    }
  },
}
</script>

<style>

</style>
